<template>
  <EntityListDisplay
      :items="permissions"
      :columns="permissionColumns"
      :hasActions="true"
  >
    <template #actions="{ item }">
      <div class="btn-group pt-3" role="group">
        <button v-if="canViewPermission" class="btn btn-success p-1 ms-1 shadow-3d" @click="viewPermission(item)" title="Ver detalles del permiso"><i class="material-icons">visibility</i></button>
        <button v-if="canEditPermission" class="btn btn-info p-1 ms-1 shadow-3d" @click="editPermission(item)" title="Editar permiso"><i class="material-icons">edit</i></button>
        <button v-if="canDeletePermission" class="btn btn-danger p-1 ms-1 shadow-3d" @click="deletePermission(item)" title="Eliminar permiso"><i class="material-icons">delete</i></button>
      </div>
    </template>
    <template #card="{ item }">
      <div class="user-card-header">
        <div class="avatar-3d">
          <i class="material-icons">vpn_key</i>
        </div>
        <div class="user-card-title">
          <span class="user-name">{{ item.name }}</span>
        </div>
      </div>
      <div class="user-card-body">
        <div class="user-info"><i class="material-icons">description</i> {{ item.description }}</div>
      </div>
    </template>
    <template #new>
      <div class="d-flex gap-2 align-items-center">
        <button v-if="canSyncPermissionsAndRoles" class="btn btn-warning btn-new-user d-flex align-items-center gap-2" @click="syncPermissionsAndRoles" :disabled="syncing">
          <i class="material-icons">{{ syncing ? 'sync' : 'sync_alt' }}</i>
          <span>{{ syncing ? 'Sincronizando...' : 'Sincronizar Permisos y Roles' }}</span>
        </button>
        <button class="btn btn-success btn-new-user d-flex align-items-center gap-2" @click="showNewPermissionModal = true">
          <i class="material-icons">add</i>
          <span>Nuevo Permiso</span>
        </button>
      </div>
    </template>
    <template #title>
  Lista de Permisos
    </template>
  </EntityListDisplay>
  <!-- Modal de nuevo permiso -->
  <div v-if="showNewPermissionModal" class="modal show">
    <div class="modal-content modal-professional">
      <div class="modal-header">
        <h4 class="modal-title">
          <i class="material-icons">add</i>
          Crear Nuevo Permiso
        </h4>
        <span class="modal-close" @click="showNewPermissionModal=false">
          <i class="material-icons">close</i>
        </span>
      </div>
      <form @submit.prevent="createPermission" class="modal-form">
        <div class="form-group">
          <label class="form-label">
            <i class="material-icons">vpn_key</i>
            Nombre del Permiso *
          </label>
          <input 
            v-model="newPermission.name" 
            class="form-control form-control-modern" 
            placeholder="Ingrese el nombre del permiso"
            required
            @blur="validatePermissionName"
          />
          <div v-if="permissionErrors.name" class="error-message">
            <i class="material-icons">error</i>
            {{ permissionErrors.name }}
          </div>
        </div>
        
        <div class="form-group">
          <label class="form-label">
            <i class="material-icons">description</i>
            Descripción
          </label>
          <textarea 
            v-model="newPermission.description" 
            class="form-control form-control-modern" 
            placeholder="Ingrese una descripción del permiso (opcional)"
            rows="3"
          ></textarea>
        </div>
        
        <div class="modal-actions">
          <button type="button" class="btn btn-secondary" @click="showNewPermissionModal=false">
            <i class="material-icons">cancel</i>
            Cancelar
          </button>
          <button type="submit" class="btn btn-primary" :disabled="!isPermissionFormValid">
            <i class="material-icons">save</i>
            Crear Permiso
          </button>
        </div>
      </form>
    </div>
  </div>
  <!-- Modal de detalle -->
  <DetailModal
    :show="showPermissionModal"
    title="Detalles de Permiso"
    subtitle="Información completa del permiso"
    icon="vpn_key"
    :data="selectedPermission"
    size="medium"
    :show-edit-button="true"
    :hidden-fields="['id', 'createdAt', 'updatedAt']"
    :field-labels="{
      name: 'Nombre del Permiso',
      description: 'Descripción'
    }"
    :field-icons="{
      name: 'vpn_key',
      description: 'description'
    }"
    @close="showPermissionModal = false"
    @edit="editPermission(selectedPermission)"
  />
  <!-- Modal de edición -->
  <div v-if="showEditModal" class="modal show">
    <div class="modal-content modal-professional">
      <div class="modal-header">
        <h4 class="modal-title">
          <i class="material-icons">edit</i>
          Editar Permiso
        </h4>
        <span class="modal-close" @click="showEditModal=false">
          <i class="material-icons">close</i>
        </span>
      </div>
      <form @submit.prevent="saveEdit" class="modal-form">
        <div class="form-group">
          <label class="form-label">
            <i class="material-icons">vpn_key</i>
            Nombre del Permiso *
          </label>
          <input 
            v-model="selectedPermission.name" 
            class="form-control form-control-modern" 
            placeholder="Ingrese el nombre del permiso"
            required
          />
        </div>
        
        <div class="form-group">
          <label class="form-label">
            <i class="material-icons">description</i>
            Descripción
          </label>
          <textarea 
            v-model="selectedPermission.description" 
            class="form-control form-control-modern" 
            placeholder="Ingrese una descripción del permiso (opcional)"
            rows="3"
          ></textarea>
        </div>
        
        <div class="modal-actions">
          <button type="button" class="btn btn-secondary" @click="showEditModal=false">
            <i class="material-icons">cancel</i>
            Cancelar
          </button>
          <button type="submit" class="btn btn-primary">
            <i class="material-icons">save</i>
            Guardar Cambios
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import EntityListDisplay from "@/components/EntityListDisplay.vue";
import DetailModal from "@/components/DetailModal.vue";
import Swal from "sweetalert2";
import { showSuccess, showError, syncPermissionsAndRoles, me } from "@/actions";

export default {
  name: "List_Permissions",
  components: { EntityListDisplay, DetailModal },
  data() {
    return {
      permissionColumns: [
        { key: "name", label: "Nombre" },
        { key: "description", label: "Descripción" }
      ],
      permissions: [],
      selectedPermission: {
        id: "",
        name: "",
        description: ""
      },
      showPermissionModal: false,
      showEditModal: false,
      showNewPermissionModal: false,
      newPermission: {
        name: "",
        description: ""
      },
      permissionErrors: {},
      syncing: false,
      currentUserEmail: ""
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'hasPermission', 'canDelete']),
    canViewPermission() {
      // Administrador tiene acceso total
      if (this.isAdmin) {
        return true;
      }
      return this.hasPermission(Permissions.SECURITY_PERMISSION_CRUD);
    },
    canEditPermission() {
      // Administrador tiene acceso total
      if (this.isAdmin) {
        return true;
      }
      return this.hasPermission(Permissions.SECURITY_PERMISSION_CRUD);
    },
    canCreatePermission() {
      // Administrador tiene acceso total
      if (this.isAdmin) {
        return true;
      }
      return this.hasPermission(Permissions.SECURITY_PERMISSION_CRUD);
    },
    canDeletePermission() {
      // Administrador tiene acceso total
      if (this.isAdmin) {
        return true;
      }
      return this.canDelete('security.permission') || this.hasPermission(Permissions.SECURITY_PERMISSION_DELETE);
    },
    isPermissionFormValid() {
      return this.newPermission.name && 
             this.newPermission.name.trim().length >= 2 &&
             !this.permissionErrors.name;
    },
    canSyncPermissionsAndRoles() {
      return this.currentUserEmail === 'admin@gmail.com';
    }
  },
  methods: {
    async loadCurrentUser() {
      try {
        const response = await me();
        const currentUser = response?.data?.data?.me || response?.data?.me;
        this.currentUserEmail = (currentUser?.email || '').trim().toLowerCase();
      } catch (error) {
        console.error('Error cargando usuario actual:', error);
        this.currentUserEmail = '';
      }
    },
    async syncPermissionsAndRoles() {
      if (!this.canSyncPermissionsAndRoles) {
        showError("Solo el usuario admin@gmail.com puede sincronizar permisos y roles.", "Acceso denegado");
        return;
      }

      const confirmed = await Swal.fire({
        title: '¿Sincronizar Permisos y Roles?',
        html: `
          <p>Esta acción sincronizará:</p>
          <ul style="text-align: left; display: inline-block;">
            <li><strong>Permisos:</strong> Desde el código a la base de datos (siempre se actualizan)</li>
            <li><strong>Roles por defecto:</strong> Solo creará roles si no existen (Administrador, Supervisor, Agente)</li>
            <li><strong>Permisos de roles:</strong> Solo se asignan a roles nuevos. Los roles existentes NO se modifican.</li>
          </ul>
          <p style="margin-top: 15px; color: #ff9800;"><strong>Nota:</strong> Los permisos de roles existentes se preservan. Puedes modificarlos desde la interfaz sin que la sincronización los sobrescriba.</p>
          <p style="margin-top: 10px; color: #d33;"><strong>¿Deseas continuar?</strong></p>
        `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, sincronizar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      });

      if (!confirmed.isConfirmed) {
        return;
      }

      this.syncing = true;
      try {
        const response = await syncPermissionsAndRoles({
          syncPermissions: true,
          syncRoles: true,
          forceRoles: false
        });

        if (response.data.data.syncPermissionsAndRoles.success) {
          const result = response.data.data.syncPermissionsAndRoles;
          const message = `
            <div style="text-align: left;">
              <p><strong>Sincronización completada exitosamente</strong></p>
              <hr>
              <p><strong>Permisos:</strong></p>
              <ul>
                <li>Creados: ${result.permissionsCreated || 0}</li>
                <li>Actualizados: ${result.permissionsUpdated || 0}</li>
                <li>Sin cambios: ${result.permissionsSkipped || 0}</li>
              </ul>
              <p><strong>Roles:</strong></p>
              <ul>
                <li>Creados: ${result.rolesCreated || 0}</li>
                <li>Actualizados: ${result.rolesUpdated || 0}</li>
              </ul>
            </div>
          `;
          
          await Swal.fire({
            title: '¡Sincronización Exitosa!',
            html: message,
            icon: 'success',
            confirmButtonText: 'Aceptar'
          });

          // Recargar permisos
          await this.fetchPermissions();
        } else {
          const error = response.data.data.syncPermissionsAndRoles.error || 'Error desconocido';
          await Swal.fire({
            title: 'Error en la Sincronización',
            text: error,
            icon: 'error',
            confirmButtonText: 'Aceptar'
          });
        }
      } catch (error) {
        console.error('Error al sincronizar:', error);
        await Swal.fire({
          title: 'Error',
          text: error.message || 'Ocurrió un error al sincronizar permisos y roles',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        });
      } finally {
        this.syncing = false;
      }
    },
    async fetchPermissions() {
      const { permissions } = await import("@/actions");
      const resPerms = await permissions();
      this.permissions = resPerms.data.data.permissions || [];
    },
    editPermission(permission) {
      this.selectedPermission = { ...permission };
      this.showEditModal = true;
    },
    async saveEdit() {
      const { updatePermission } = await import("@/actions");
      try {
        const res = await updatePermission({
          id: this.selectedPermission.id,
          name: this.selectedPermission.name,
          description: this.selectedPermission.description
        });
        if (res.data.data.updatePermission && res.data.data.updatePermission.permission) {
          this.fetchPermissions();
          this.showEditModal = false;
          showSuccess("Permiso actualizado correctamente", "Permiso actualizado", { timer: 1800 });
        } else {
          showError(res.data.data.updatePermission.error || "Error al actualizar permiso", "Error al actualizar");
        }
      } catch (e) {
        showError(e.message || "Error de conexión", "Error al actualizar");
      }
    },
    viewPermission(permission) {
      this.selectedPermission = permission;
      this.showPermissionModal = true;
    },
    async deletePermission(permission) {
      const result = await Swal.fire({
        title: `¿Eliminar permiso '${permission.name}'?`,
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar"
      });
      if (result.isConfirmed) {
        const { deletePermission } = await import("@/actions");
        try {
          const res = await deletePermission(permission.id);
          if (res.data.data.deletePermission && res.data.data.deletePermission.ok) {
            this.permissions = this.permissions.filter(p => p.id !== permission.id);
            showSuccess("El permiso ha sido eliminado correctamente.", "Permiso eliminado", { timer: 1800 });
          } else {
            showError(res.data.data.deletePermission.error || "No se pudo eliminar el permiso.", "Error al eliminar");
          }
        } catch (e) {
          showError("Error de conexión.", "Error al eliminar");
        }
      }
    },
    validatePermissionName() {
      this.permissionErrors = { ...this.permissionErrors };
      
      if (!this.newPermission.name || this.newPermission.name.trim().length < 2) {
        this.permissionErrors.name = 'El nombre del permiso debe tener al menos 2 caracteres';
      } else {
        delete this.permissionErrors.name;
      }
    },
    
    async createPermission() {
      // Validar antes de enviar
      this.validatePermissionName();
      
      if (Object.keys(this.permissionErrors).length > 0) {
        showError("Por favor corrija los errores en el formulario", "Error de validación");
        return;
      }
      
      const { createPermission } = await import("@/actions");
      try {
        const res = await createPermission(this.newPermission);
        if (res.data.data.createPermission && res.data.data.createPermission.permission) {
          this.fetchPermissions();
          this.showNewPermissionModal = false;
          this.newPermission = { name: "", description: "" };
          this.permissionErrors = {};
          showSuccess("Permiso creado correctamente", "Permiso creado", { timer: 1800 });
        } else {
          showError(res.data.data.createPermission.error || "Error al crear permiso", "Error al crear");
        }
      } catch (e) {
        showError("Error de conexión", "Error al crear");
      }
    }
  },
  async mounted() {
    await Promise.all([
      this.fetchPermissions(),
      this.loadCurrentUser()
    ]);
  }
}
</script>

<style scoped>
.btn-new-user {
  font-size: 1.1rem;
  padding: 0.5rem 1.2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(2, 33, 38, 0.08);
  background: linear-gradient(90deg, #3A9F1D 0%, #5fe939 100%);
  color: #fff;
  font-weight: bold;
  transition: background 0.2s;
}

.btn-new-user:hover {
  background: linear-gradient(90deg, #5fe939 0%, #3A9F1D 100%);
  color: #fff;
}

.modal {
  /* Spinner global */

  .site-spinner {
    width: 60px;
    height: 60px;
    border: 7px solid #e0e0e0;
    border-top: 7px solid #3A9F1D;
    border-right: 7px solid #5fe939;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 15px;
  width: 50%;
}

/* Estilos profesionales para formularios */
.modal-professional {
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  border: none;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 25px;
}

.modal-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.4rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.modal-title .material-icons {
  color: #3A9F1D;
  font-size: 1.6rem;
}

.modal-close {
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  background-color: #f8f9fa;
  color: #dc3545;
}

.modal-close .material-icons {
  font-size: 1.4rem;
}

.modal-form {
  padding: 0;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  font-size: 0.95rem;
}

.form-label .material-icons {
  font-size: 1.1rem;
  color: #3A9F1D;
}

.form-control-modern {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background-color: #fff;
  font-family: inherit;
}

.form-control-modern:focus {
  outline: none;
  border-color: #3A9F1D;
  box-shadow: 0 0 0 3px rgba(58, 159, 29, 0.1);
}

.form-control-modern::placeholder {
  color: #adb5bd;
  font-style: italic;
}

textarea.form-control-modern {
  resize: vertical;
  min-height: 80px;
}

.error-message {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #dc3545;
  font-size: 0.85rem;
  margin-top: 6px;
  font-weight: 500;
}

.error-message .material-icons {
  font-size: 1rem;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 2px solid #f0f0f0;
  margin-top: 25px;
}

.btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
}

.btn-primary {
  background: linear-gradient(135deg, #3A9F1D 0%, #5fe939 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(58, 159, 29, 0.3);
}

.btn-primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #2d7a16 0%, #4dd32a 100%);
  box-shadow: 0 6px 16px rgba(58, 159, 29, 0.4);
  transform: translateY(-1px);
}

.btn-primary:disabled {
  background: #6c757d;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.btn-secondary {
  background: #6c757d;
  color: white;
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

.btn-secondary:hover {
  background: #5a6268;
  box-shadow: 0 6px 16px rgba(108, 117, 125, 0.4);
  transform: translateY(-1px);
}

.btn .material-icons {
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .modal-professional {
    width: 95%;
    margin: 10px;
  }
  
  .modal-actions {
    flex-direction: column;
  }
  
  .btn {
    justify-content: center;
  }
}

.modal {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.modal.show {
  opacity: 1;
}

@media (max-width: 550px) {
  .modal-content {
    width: 90%;
    margin-top: 20%;
  }
}

.user-card .card-actions {
  margin-top: 1rem;
  display: flex;
  gap: 0.5rem;
}

.user-card-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.1rem;
}

.avatar-3d {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3A9F1D 0%, #5fe939 100%);
  box-shadow: 0 4px 16px #3A9F1D44, 0 1px 0 #5fe939 inset;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 2.2rem;
  margin-right: 1.1rem;
}

.user-card-title {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-weight: bold;
  font-size: 1.18rem;
  color: #2a4d1b;
  text-shadow: 0 1px 0 #fff;
}

.user-group {
  font-size: 0.98rem;
  color: #5fe939;
  font-weight: 500;
  margin-top: 2px;
}

.user-card-body {
  margin-bottom: 1.1rem;
}

.user-info {
  display: flex;
  align-items: center;
  font-size: 1.04rem;
  color: #3A9F1D;
  margin-bottom: 0.4rem;
}

.user-info i {
  font-size: 1.1rem;
  margin-right: 0.5rem;
  color: #5fe939;
}

</style>
